import { FormikProps } from "formik";
import { IPortalAuthenticationModel } from "../../models";
import { FormikUtils } from "../../utils";
import { AvisConfirmButton } from "../shared/components/buttons";
import { AvisInputText } from "../shared/components/inputs";
import { EIdLogin } from "./EIdLogin";

interface ILoginFormProps {
  bag: FormikProps<IPortalAuthenticationModel>;
  loading: boolean;
  setError: (error?: string) => void;
  setSubmitting: (value: boolean) => void;
}

export function LoginForm(props: Readonly<ILoginFormProps>) {
  const { bag, loading } = props;

  return (
    <div className="login-form">
      <AvisInputText<IPortalAuthenticationModel>
        placeholder="Lietotājvārds"
        bag={bag}
        bagField="username"
        disabled={loading}
        spacing="large"
        onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        reserveErrorMessageSpace={true}
      />
      <AvisInputText<IPortalAuthenticationModel>
        placeholder="Parole"
        bag={bag}
        bagField="password"
        disabled={loading}
        spacing="large"
        type="password"
        onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        reserveErrorMessageSpace={true}
      />
      <AvisConfirmButton
        label="Pieslēgties"
        onClick={() => bag.submitForm()}
        disabled={loading}
      />
      <EIdLogin {...props} loading={loading} />
    </div>
  );
}
